
import React from 'react';
import { Card, CardHeader, Collapse, CardBody } from 'reactstrap';
import PBIcon from '../PBIcon';
import './style.scss';

const AccordionSection = ({
  isOpen,
  onToggle,
  label,
  children,
  showDivider
}) => (
  <div className="record-accordion-box">
    <Card>
      <CardHeader onClick={onToggle}>
        <div className="accordion-label">{label}</div>
        <div className="arrow-icon">
          {isOpen ? <PBIcon name="chevron-up" /> : <PBIcon name="chevron-down" />}
        </div>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody>{children}</CardBody>
      </Collapse>
    </Card>
    {showDivider && <div className="card-divider" />}
  </div>
);

export default AccordionSection;
